module.exports = __webpack_public_path__ + "img/18-mob.b321efbe.svg";